import { make } from 'vuex-pathify'
import store from '../index'
import { getQueryFromFilter, showError, showSuccess } from '@/util/helpers'
import axios from 'axios'

const state = {
  classification: {},
  classifications: {
    data: [],
    count: 0,
    limit: 50,
  },

  filter: {
    page: 1,
    itemsPerPage: 25,
    sortBy: ['description'],
    sortDesc: [false],
  },

  type: 'add',
  loading: false,
  dialog: false,
}

const mutations = make.mutations(state)
const actions = {
  add: ({ state }, type) => {
    state.classification = {
      type,
      companyId: store.get('authStore@currentCompany').id,
    }
    state.type = 'add'
    state.dialog = true
    state.filter.type = type
  },

  edit: ({ state }, id, type) => {
    state.loading = true
    store.dispatch('classificationStore/getById', id)
      .then(res => {
        state.classification = res.data
        state.type = 'edit'
        state.dialog = true
      })
      .catch(showError)
      .finally(() => (state.loading = false))
  },

  save: ({ state }, classification) => {
    const id = classification.id
    const method = id ? 'put' : 'post'
    state.loading = true
    return axios[method](`${process.env.VUE_APP_API_URL}/classification/${id || ''}`, classification)
      .then(_ => {
        store.dispatch('classificationStore/get')
        showSuccess('Classificação salva com sucesso!')
      })
      .catch(showError)
      .finally(() => (state.loading = false))
  },

  get: async ({ state }, filter = state.filter) => {
    return axios.get(`${process.env.VUE_APP_API_URL}/classification?${getQueryFromFilter(filter)}`)
      .then(res => {
        state.classifications = res.data
        return res.data
      })
      .catch(showError)
      .finally(() => (state.loading = false))
  },

  getById: (context, id) => axios.get(`${process.env.VUE_APP_API_URL}/classification/${id}`).catch(showError),

  remove: ({ state }, id) => {
    state.loading = true
    return axios.delete(`${process.env.VUE_APP_API_URL}/classification/${id}`)
      .then(_ => {
        store.dispatch('classificationStore/get')
        showSuccess('Classificação excluída com sucesso!')
      })
      .catch(showError)
      .finally(() => (state.loading = false))
  },
}
const getters = {
  getById: state => id => {
    return state.classifications.data.find((u) => String(u.id) === String(id))
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
